import React, { useState } from 'react';
import AgentRunner from '../../agents/AgentRunner';
import ChatbotAgent from './ChatbotAgent';
import OneDriveModal from '../../views/admin/settings/OneDriveModal';
import Button from '../common/Button';

const agents = [
  'Audit planer', 'pending Work Reviewer', 'BS Analyser', 'PL Analyser',
  'CF Analyser', 'Ratio Analyser', 'KYC Analyser', 'Substantantial Test Reviewer',
  'CARO Reviewer', 'TB Analyser', 'DB Analyser', 'DB Analyser',
];

const colors = [
  '#E3F2FD', '#FFF3E0', '#F3E5F5', '#E8F5E9',
  '#FFFDE7', '#FBE9E7', '#E0F7FA', '#F1F8E9',
  '#FCE4EC', '#ECEFF1', '#FFF8E1', '#EDE7F6',
];

const GeneralTab: React.FC = () => {
  const [openAgent, setOpenAgent] = useState<string | null>(null);
  const [inputContext, setInputContext] = useState<any>(null);
  const [chatbotOpen, setChatbotOpen] = useState<boolean>(false);
  const [oneDriveModalOpen, setOneDriveModalOpen] = useState(false);
  const [oneDriveData, setOneDriveData] = useState<any[]>([]);
  const [oneDriveLoading, setOneDriveLoading] = useState(false);
  const [oneDriveError, setOneDriveError] = useState<string | null>(null);

  function handleOpenAgent(label: string) {
    if (label.toLowerCase().includes('audit')) {
      setOpenAgent('audit_planner');
      setInputContext({ entityId: 'ENT-001', reportingPeriod: '2024-03', currency: 'INR', industry: 'Manufacturing' });
    }
  }

  const handleOneDriveClick = async () => {
    setOneDriveModalOpen(true);
    setOneDriveLoading(true);
    setOneDriveError(null);
    setOneDriveData([]);
    const link = "https://sagsol-my.sharepoint.com/:x:/g/personal/md_sagsol_in/IQCyt4TYJj68R66SalKnVfSSAbboAmYN7bYb8rc1fuuH-KU?e=2E3pac";
    try {
      const response = await fetch('http://localhost:5001/api/onedrive/read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ link }),
      });
      if (!response.ok) { const errorData = await response.json(); throw new Error(errorData.error || 'Failed to fetch data'); }
      const result = await response.json();
      setOneDriveData(result.data);
    } catch (err: any) {
      setOneDriveError(err.message);
    } finally {
      setOneDriveLoading(false);
    }
  };

  return (
    <div className="netbody-card flex flex-col h-full min-h-[500px]">

      <div className="netbody-header">
        <div className="flex items-center gap-2 ml-auto">
          <Button variant="secondary-outline" onClick={handleOneDriveClick} title="Read from OneDrive" data-testid="BTN_settings_general_onedrive">
            📊 OneDrive
          </Button>
          <Button variant="fill" onClick={() => setChatbotOpen(true)} title="Open AI Chat Assistant" data-testid="BTN_settings_general_chatbot">
            💬 AI Chat
          </Button>
        </div>
      </div>

      <div className="netbody-content">
        <div className="scroll-container flex-1 overflow-hidden">
          <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>
            Click an agent to run a demo analysis.
          </p>
          <div className="agents-grid" role="list">
            {agents.map((label, idx) => (
              <button
                key={`${label}-${idx}`}
                className="agent-card"
                style={{ backgroundColor: colors[idx % colors.length] }}
                role="listitem"
                onClick={() => handleOpenAgent(label)}
                data-testid={`BTN_settings_general_agent_${idx}`}
              >
                <div className="agent-icon" aria-hidden>🤖</div>
                <div className="agent-label">{label}</div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {openAgent && (
        <AgentRunner agentName={openAgent} inputContext={inputContext} onClose={() => setOpenAgent(null)} />
      )}
      <ChatbotAgent isOpen={chatbotOpen} onClose={() => setChatbotOpen(false)} />
      <OneDriveModal isOpen={oneDriveModalOpen} onClose={() => setOneDriveModalOpen(false)} data={oneDriveData} isLoading={oneDriveLoading} error={oneDriveError} />
    </div>
  );
};

export default GeneralTab;
